import { useTranslation } from "react-i18next";

import { BatchChangeRequestsJobType } from "~/common/types";

export function JobTypeLabel({ type }: { type: BatchChangeRequestsJobType }) {
  const { t } = useTranslation();

  switch (type) {
    case BatchChangeRequestsJobType.EntityComposer:
      return t("model.batchChangeRequestsJob.jobType.entityComposer");
    case BatchChangeRequestsJobType.RelationComposer:
      return t("model.batchChangeRequestsJob.jobType.relationComposer");
    case BatchChangeRequestsJobType.S3Script:
      return t("model.batchChangeRequestsJob.jobType.s3Script");
    default:
      return "";
  }
}
